import { render, staticRenderFns } from "./abnormal-manage.vue?vue&type=template&id=613e9e4e&scoped=true&"
import script from "./abnormal-manage.vue?vue&type=script&lang=js&"
export * from "./abnormal-manage.vue?vue&type=script&lang=js&"
import style0 from "./abnormal-manage.vue?vue&type=style&index=0&id=613e9e4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613e9e4e",
  null
  
)

export default component.exports